var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTopicDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.75C14 5.41537 14 4.24805 13.5277 3.36441C13.1548 2.6667 12.5833 2.09525 11.8856 1.72231C11.0019 1.25 9.83463 1.25 7.5 1.25V1.25C5.16537 1.25 3.99805 1.25 3.11441 1.72231C2.4167 2.09525 1.84525 2.6667 1.47231 3.36441C1 4.24805 1 5.41537 1 7.75V12.25C1 13.1928 1 13.6642 1.29289 13.9571C1.58579 14.25 2.05719 14.25 3 14.25H7.5C9.83463 14.25 11.0019 14.25 11.8856 13.7777C12.5833 13.4048 13.1548 12.8333 13.5277 12.1356C14 11.2519 14 10.0846 14 7.75V7.75Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 6.125L9.9375 6.125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 9.375H7.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTopicDiscussion);
export default __webpack_public_path__ + "static/media/filter-topic-discussion.2bdddbcd155f5266fea449d4175ed64c.svg";
export { ForwardRef as ReactComponent };